











import { computed, defineComponent, PropType } from '@vue/composition-api';
import VideoEmbed from '@front-app/components/video/VideoEmbed.vue';
import { convertVideoIdToUrl } from '@front-app/util/video';
import { HighlightsVideoMeta } from '@front-app/modules/group/highlights/model';
import { SHORTENED_YOUTUBE_HOSTNAME } from '@front-app/components/video/util';

export default defineComponent({
	components: {
		VideoEmbed,
	},
	props: {
		meta: {
			type: Object as PropType<HighlightsVideoMeta>,
			required: true,
		},
	},
	setup(props) {
		const videoSrc = computed(() => {
			// Use a provided source URL or construct one from id and video provider type
			if (props.meta.src) {
				// Convert shortened YouTube URL as otherwise video id cannot later be parsed from it
				const hostname = new URL(props.meta.src).host;
				if (hostname === SHORTENED_YOUTUBE_HOSTNAME) {
					return convertVideoIdToUrl(props.meta.videoId, props.meta.type);
				}
				return props.meta.src;
			}
			return convertVideoIdToUrl(props.meta.videoId, props.meta.type);
		});

		return {
			videoSrc,
		};
	},
});
